import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"abs\">\r\n    {{yield}}\r\n</div>",{ moduleName: "dac-error-budget/components/formulas/helpers/abs.hbs" })